import jsPDF from 'jspdf';
import 'jspdf-autotable';

const myJsPDF = jsPDF;

export default myJsPDF